import { FDealType, FOfferType } from '../../../../utils/category';

export const getMessageKeyParameter = (offerType: FOfferType | null, serpType: FDealType | null) => {
  if (serpType !== FDealType.Sale) {
    return 'default';
  }

  switch (offerType) {
    case FOfferType.FlatNew:
      return 'newBuildingFlatSale';

    case FOfferType.FlatOld:
      return 'FlatSale';

    default:
      return 'default';
  }
};
